import React from "react";
import { Icon } from '@iconify/react';
import {Typography} from "@mui/material";

const Footer = (props) => {
    return (
        <div style={{backgroundColor: props.bgColor, color: 'white', paddingBottom: '10%'}}>
            <div style={{textAlign: 'center', fontSize: '32px', paddingBottom: '1%'}}>
                <a href="https://www.linkedin.com/in/simardeepsingh99/" target="_blank" rel="noreferrer"
                   className="mr-4">
                    <Icon icon="bx:bxl-linkedin" style={{color: '#16a0ec'}}/>
                </a>
                <a href="https://github.com/tombstoneghost" target="_blank" rel="noreferrer"
                   className="mr-4">
                    <Icon icon="akar-icons:github-fill" style={{color: 'white'}}/>
                </a>
                <a href="https://twitter.com/simardeep99" target="_blank" rel="noreferrer"
                   className="mr-4">
                    <Icon icon="akar-icons:twitter-fill"  style={{color: '#52a0ff'}}/>
                </a>
                <a href="https://app.hackthebox.eu/profile/276640" target="_blank" rel="noreferrer"
                    className="mr-4">
                    <Icon icon="simple-icons:hackthebox" style={{color: '#9fef00'}}/>
                </a>
                <a href="https://tryhackme.com/p/tombstoneGhost" target="_blank" rel="noreferrer">
                    <Icon icon="simple-icons:tryhackme" style={{color: 'white'}}/>
                </a>
            </div>
            <div className="ml-auto mr-auto" style={{width: '25%', borderTop: '2px solid white'}}/>
            <div style={{textAlign: 'center', marginTop: '1%'}}>
                <Typography>
                    &copy; 2022 Simardeep Singh | Some Rights Reserved
                </Typography>
            </div>
        </div>
    )
};

export default Footer;